import axios from 'axios';
import { AMP_URL, REGEX_SHORTEST_URL, API_URL, REGEX_AMP_URL, ARTICLE_PATH } from '../constants/config';
import { getArticleUrl } from '../modules/common/utils/routingUtils';
import { getLegacyId } from '~/modules/common/utils/stringUtils';
const base = API_URL + '/v3.5';

export default async ({ redirect, req, params }) => {
  const { slug } = params;
  if (!req) {
    return true;
  }
  const reqUrl = req?._parsedUrl?.pathname || req?.url || '';
  const legacyId = getLegacyId(slug);
  const isAmpUrl = REGEX_AMP_URL.test(reqUrl);
  const isShortestUrl = REGEX_SHORTEST_URL.test(reqUrl);

  if (!legacyId) {
    if (isShortestUrl) {
      redirect(301, `/${ARTICLE_PATH}/${legacyId}`);
    } else if (isAmpUrl) {
      redirect(301, `${AMP_URL}/${ARTICLE_PATH}/${legacyId}`);
    } else {
      return true;
    }
  }
  let article, redirectUrl;
  // get article data
  try {
    const { data: result } = await axios.get(`${base}/articles/${legacyId}?fields=title,originalTitle,legacyId`);
    article = result.data;
    redirectUrl = getArticleUrl({ article });
  } catch (error) {
    const {
      data: { data },
    } = error.response;
    if (data?.action === 'redirect') {
      redirect(301, data?.payload?.route);
    }
    if (isShortestUrl) {
      redirect(301, `/${ARTICLE_PATH}/${legacyId}`);
    }
    console.log('error', error);
    return true;
  }
  if (article && isAmpUrl) {
    redirect(301, `${AMP_URL}${redirectUrl}`);
  } else if (!article && isAmpUrl) {
    redirect(301, `${AMP_URL}/${ARTICLE_PATH}/${legacyId}`);
  } else if (article && reqUrl !== redirectUrl) {
    redirect(301, redirectUrl);
  } else if (!article && isShortestUrl) {
    redirect(301, `/${ARTICLE_PATH}/${legacyId}`);
  } else {
    return true;
  }
};
